import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createSectionValidationSchema = () => {
  const acSectionValidationSchema = yup
    .object({
      title: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_XS, i18n.t("validation.title.ac.charCount.invalid")),
      titleEn: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_XS, i18n.t("validation.title.ac.charCount.invalid")),
    })
    .concat(createPositionValidationSchema());
  return acSectionValidationSchema;
};

export const createPageValidationSchema = () => {
  yup.setLocale({
    mixed: {
      required: i18n.t("validation.field.required"),
    },
  });

  const acPageValidationSchema = yup
    .object({
      title: yup
        .string()
        .required()
        .max(INPUT_LENGTH.MAX_INPUT_LENGTH_XS, i18n.t("validation.title.ac.charCount.invalid")),
      titleEn: yup
        .string()
        .required()
        .max(INPUT_LENGTH.MAX_INPUT_LENGTH_XS, i18n.t("validation.title.ac.charCount.invalid")),
    })
    .concat(createPositionValidationSchema());
  return acPageValidationSchema;
};

const createPositionValidationSchema = () => {
  yup.setLocale({
    number: {
      positive: i18n.t("validation.field.positive.number"),
    },
  });

  const positionValidationSchema = yup.object({
    position: yup.number().typeError(i18n.t("validation.field.positive.number")).positive(),
  });

  return positionValidationSchema;
};
